import {Injectable, Inject} from 'ng-metadata/core';
import {TemplateUtil} from '../../nddUtils/templateUtil.service';
import {getVid} from '../../appConfig/appConfigForward';
const flatten = require('lodash/flatten');
const get = require('lodash/get');

@Injectable()
export class PushtoService {
    private PUSHTO_API_URL: string;
    private vid:string = getVid();

    constructor(private templateUtil: TemplateUtil,
                @Inject('$http') private $http: ng.IHttpService,
                @Inject('restBaseURLs') private restBaseURLs) {
        this.PUSHTO_API_URL= restBaseURLs.actionsBaseURL+'/pushto/';
    }

    public getServiceUrl(items, selectedIds, target,additionalParams?: Object) {
        //TODO: call rest api to get the service url
        let itemsToSend = this.removeProblematicFields(items);
        let payload = this.buildPayload(flatten(itemsToSend),selectedIds,additionalParams);
        console.log("payload push to");
        console.log(payload);
        return this.$http.post(this.PUSHTO_API_URL + target+"?vid="+this.vid, payload);
    }
    
    private buildPayload(items: Object, selectedIds: any ,additionalParams?:Object) {
        let json = {"records":selectedIds ? selectedIds: items
                    };
        for(let key in additionalParams){
            json[key] = additionalParams[key];
        };
        return json;
    }


    private removeProblematicFields(items) {
        let itemsToSend: Array<object> = [];
        try {
            for (let i = 0; i < items.length; i++) {
                if (items[i]) {
                    let item = JSON.parse(JSON.stringify(items[i]));
                    if (get(item, 'delivery.electronicServices', []).length > 0) {
                        // the public note field break sometimes the json format of the payload
                        item.delivery.electronicServices[0].publicNote = '';
                    }
                    itemsToSend.push(item);
                }
            }
            return itemsToSend;
        }
        catch(e){
            return items;
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/pushto.service.ts